import React, { type ForwardedRef, forwardRef } from 'react';

import { Sheet } from '@pkg/components';
import { useAppSelector } from '@pkg/hooks';

import { FollowerSearch } from './components';
import { type SearchCommonProps } from './types';

import { StyledSearch } from './styles';

type SearchProps = Omit<SearchCommonProps, 'currentUserId'>;

function SearchComponent({ ...inputProps }: SearchProps, ref: ForwardedRef<HTMLDivElement>) {
    const currentUserId = useAppSelector(({ user }) => user.userAccount?.user?.id ?? '');

    return (
        <Sheet.Layout.Section>
            <StyledSearch ref={ref}>
                <FollowerSearch {...inputProps} currentUserId={currentUserId} />
            </StyledSearch>
        </Sheet.Layout.Section>
    );
}

export const Search = forwardRef(SearchComponent);
